"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WatchThemDieAbilityHandler = exports.WatchThemDieActorAbilityFactory = exports.WatchThemDieAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
class WatchThemDieAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.WatchThemDie;
        this.__typeName = "WatchThemDie";
    }
}
exports.WatchThemDieAbilityArgs = WatchThemDieAbilityArgs;
let WatchThemDieActorAbilityFactory = class WatchThemDieActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("WatchThemDie", "Self", 0);
    }
};
WatchThemDieActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("WatchThemDie")
], WatchThemDieActorAbilityFactory);
exports.WatchThemDieActorAbilityFactory = WatchThemDieActorAbilityFactory;
let WatchThemDieAbilityHandler = class WatchThemDieAbilityHandler {
    init(sequence, container, actorId) {
        const attributes = [
            __1.AttributeType.Vitality,
            __1.AttributeType.Power,
            __1.AttributeType.Focus,
            __1.AttributeType.Toughness
        ];
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            effect: new __1.Passive_WatchThemDieEffectArgs(attributes, 5),
            duration: Duration_1.Duration.Permanent,
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
WatchThemDieAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.WatchThemDie)
], WatchThemDieAbilityHandler);
exports.WatchThemDieAbilityHandler = WatchThemDieAbilityHandler;
